<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" ref="tableRef" tableId="DcCosCustomerChangeTask">
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" label="客户区域">
              <CustomerAreaCascader appId="cos_fbu" type="search" v-model:ids="queryForm.manageAreaList" />
            </dc-form-item>
            <dc-form-item name="arkCode" label="客户负责人">
              <user-select v-model:value="queryForm.seller" />
            </dc-form-item>
            <dc-form-item name="arkCode" label="创建人">
              <user-select v-model:value="queryForm.createBy" />
            </dc-form-item>
            <dc-form-item name="arkCode" label="创建时间">
              <cos-range-picker v-model:startTime="queryForm.startTime" v-model:endTime="queryForm.endTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'manageAreaId'">
            <CustomerAreaCascaderText appId="cos_fbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'msg'">
            <p>新线索数量：{{ record.clueNum || 0 }}</p>
            <p>新签约客户数量：{{ record.customerContractNum || 0 }}</p>
            <p>老成交客户新机会额：{{ record.customerDealAmount || 0 }}</p>
            <p>新成交客户数量：{{ record.customerDealNum || 0 }}</p>
            <p>新潜在客户数量：{{ record.customerPotentialNum || 0 }}</p>
          </template>
          <template v-if="column.dataIndex === 'monthDate'">
            <p>{{ text ? dayjs(text).format('YYYY/MM') : '--' }}</p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'fbu_cuschangetask_edit_btn'">编辑</a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_cuschangetask_delete_btn'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="'fbu_cuschangetask_add_btn'">新增</a-button>
          <ImportBtn
            action="/fbu/api/customerConversionTask/import"
            templateUrl="/fbu/api/customerConversionTask/template/download"
            @success="success('search')"
            v-permission="'fbu_cuschangetask_import_btn'"
            >导入</ImportBtn
          >
          <!-- <a-button type="primary" @click="handleTempleExport()">导入模板</a-button> -->
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import dayjs from 'dayjs'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import {
  customerConversionTaskList,
  customerConversionTaskDelete
  // customerConversionTaskImportTemple
} from '@/api/gucangSales/businessRuleSetting'
import ImportBtn from '@/components/ImportBtn'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'

import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
export default { name: 'DcCosFbuCustomerChangeTask' }
</script>
<script setup lang="ts">
const editModalRef = ref()

const tableRef = ref()
const queryForm = reactive({
  startTime: '',
  endTime: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await customerConversionTaskList({ ...params, appId: 'cos_fbu' })
  callBack(res)
}
const columns = computed(() => [
  { title: '客户区域', dataIndex: 'manageAreaId' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '任务情况', dataIndex: 'msg' },
  { title: '月度', dataIndex: 'monthDate' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: { seller: string; id: any }) => {
  Modal.delete({
    onOk() {
      customerConversionTaskDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// const handleTempleExport = async () => {
//   try {
//     const res = await customerConversionTaskImportTemple()
//   } catch (error) {
//     console.log('error: ', error)
//   }
// }
</script>

<style scoped></style>
